<template>
  <div :id="type.id" class="list-box-container">
    <template>
      <div class="d-flex list-box-header col-12 pointer"
           @click="view($event, type.id)"
      >
        <div class="pl-0 list-box-header-left col-lg-12 col-12 pr-3">
          <div class="pl-0 d-flex align-items-center col-12">
            <div class="list-box-status align-items-start col-12">
              <span class="ref-id">
                {{ type.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    view(event, id) {
      if (event.button === 1) {
        window.open(this.$router.resolve(`claim-types/edit/${id}`).href, '_blank');
      } else {
        this.$router.push(`claim-types/edit/${id}`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
.list-box-status {
  align-items: normal;
}
.list-box-header {
  min-height: 66px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/ClaimTypes/SettingsClaimTypesBlock.vue